module.exports = __webpack_public_path__ + "static/img/img10.decb2b0b.png";